module.exports = __webpack_public_path__ + "img/asset-group-criticality-edit.eaa860bf.png";